import { Paper, styled } from '@mui/material';

export const StyledRecordWrap = styled(Paper)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '12px',
	borderRadius: '16px',
	width: '100%',
	padding: '8px',
});

export const StyledRecorderPlayerWrap = styled('div')({
	width: '100%',
	flex: 1,
	height: '55px',

	'& audio': {
		width: '100%',
		height: '100%',
	},
});
